import { WorkoutExerciseProps } from "../types";
import { Timer } from "../../exercise/Timer";
import { WorkoutCompletion } from "./completion/WorkoutCompletion";
import { SetCompletionCheck } from "./set-completion/SetCompletionCheck";
import { SetProgress } from "./set-progress/SetProgress";
import { ExerciseList } from "./exercise-list/ExerciseList";

export const WorkoutExercise = ({
  exercise,
  currentSetIndex,
  completedSets,
  showCompletionCheck,
  showTimer,
  isExerciseRest,
  onSetComplete,
  onTimerComplete,
  onTimerSkip,
  allExercises = [],
  onExerciseSelect,
}: WorkoutExerciseProps) => {
  const handleSetComplete = (exerciseId: string, setIndex: number) => {
    if (!completedSets[exerciseId]?.[setIndex]) {
      onSetComplete(exerciseId, setIndex);
    }
  };

  const areAllExercisesCompleted = () => {
    return allExercises.every(ex => 
      completedSets[ex.id]?.every(setCompleted => setCompleted)
    );
  };

  if (areAllExercisesCompleted()) {
    return <WorkoutCompletion />;
  }

  if (showCompletionCheck) {
    return <SetCompletionCheck />;
  }

  // Utilizar directamente los valores de Supabase sin valores predeterminados
  const exerciseRestTime = exercise.exercise_rest_time;
  const setRestTime = exercise.set_rest_time;

  console.log('Rest times in WorkoutExercise:', { 
    exerciseRestTime, 
    setRestTime, 
    rawExerciseRestTime: exercise.exercise_rest_time,
    rawSetRestTime: exercise.set_rest_time
  });

  return (
    <>
      {showTimer && (
        <Timer
          duration={isExerciseRest ? exerciseRestTime : setRestTime}
          isExerciseRest={isExerciseRest}
          onComplete={onTimerComplete}
          onSkip={onTimerSkip}
        />
      )}
      {!showTimer && (
        <div className="w-full max-w-md space-y-1 pb-safe-area bg-white/5 dark:bg-white/[0.03] backdrop-blur-xl border border-white/10 p-8 rounded-3xl shadow-2xl overflow-y-auto max-h-[85vh] [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <SetProgress
            currentSetIndex={currentSetIndex}
            setData={exercise.set_data[currentSetIndex]}
            exerciseId={exercise.id}
            completedSets={completedSets}
            totalSets={exercise.sets}
            onSetComplete={handleSetComplete}
            videoUrl={exercise.video_url}
          />
          <ExerciseList
            exercises={allExercises}
            activeExerciseId={exercise.id}
            completedSets={completedSets}
            onExerciseSelect={onExerciseSelect}
          />
        </div>
      )}
    </>
  );
};
